import React, { useState } from 'react'

import api from '../../../services/api'
import Alert from '../../../components/Alert'
import { ButtonAdd } from '../../../components/ButtonAdd'

export default function AdicionarDominio({ key_id, api_id, afterCreate }) {
  const [alert, setAlert] = useState()
  const [dominio, setDominio] = useState('')

  async function saveDominio(e) {
    e.preventDefault()
    const button = e.target
    button.disabled = true
    const r = await api
      .post(`/chaves/${key_id}/dominios`, {
        key_id,
        url: dominio
      })
      .then(data => data)
      .catch(error => error.response.data)
    if (r.error) {
      setAlert(<Alert color="danger">{r.error.message}</Alert>)
    } else {
      setAlert(<Alert color="success">Domínio adicionado!</Alert>)
      afterCreate()
      setDominio('')
    }
    button.disabled = false
  }

  return (
    <>
      {alert}
      <div className="mb-3">
        <div className="field is-horizontal">
          <div className="field-body">
            <div className="field">
              <div className="control">
                <input
                  id="dominio-chave"
                  className="input"
                  placeholder="URL com protocolo"
                  type="text"
                  value={dominio}
                  onChange={e => setDominio(e.target.value)}
                />
              </div>
            </div>
            <ButtonAdd small={false} onClick={e => saveDominio(e)}></ButtonAdd>
          </div>
        </div>
      </div>
    </>
  )
}
